import { render } from "./imperr.vue?vue&type=template&id=8049433a"
import script from "./imperr.vue?vue&type=script&lang=js"
export * from "./imperr.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\work\\project\\intelegent\\ips\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__